export default __webpack_public_path__ + "static/media/ramenswap.703b5cb2.png";